import  {useContext, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Menus from './menus';
import { Home } from '@material-ui/icons';
import { FlexRowDiv } from './menuStyle';
import FlexMobileContainer from "./flex/flexMobileContainer";
import FlexMobileNotShow from './flex/flexMobileNotShow';
import MobileNavbar from "./mobileNavbar";
import NavbarMenu from './navbarMenu';
import UserMenu from './userMenu';
import { AppContext } from '../../context/appContext';
import axios from 'axios';
import { ServerUrl } from "../../constants";

const NavbarComponent = (props) => {
  const { CurrentUser, QuickSightUrl, dispatch } = useContext(AppContext);

  useEffect(() => {
    if (CurrentUser && !QuickSightUrl) {
      axios.get(`${ServerUrl}/Auth/GetTexasDashboardUrl`, {
        headers: {
          'Authorization': "Bearer " + CurrentUser.token,          
        }
      }).then(res => {
        dispatch({type:'QUICKSIGHT_URL', data: res.data});
      }, err => {
        console.log("Fail to get dashboard Url.")
      }); 
    }
  }, [CurrentUser, QuickSightUrl, dispatch]);

  return (
    <div style={{backgroundColor: '#3880ff', position: 'sticky', top: '0', zIndex: '1000', marginBottom: '0px', height: '60px', width: '100%'}}>
      <FlexMobileContainer style={{display: 'flex', alignItems: 'center', height: '60px'}}>
          <FlexMobileNotShow minWidth={768} style={{width: '100%', justifyContent: 'space-between', overflow: 'hidden'}} >
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Link style={{ textDecoration: 'none', marginRight: '10px' }} to="/">
                  <FlexRowDiv>
                    <Home fontSize="small" />
                    <span style={{marginLeft: '6px'}}>Home</span>
                  </FlexRowDiv>
                </Link>
              </div>
              {CurrentUser && Menus.map((menu, index) => {
                return (
                  <NavbarMenu key={index} menu={menu} />
                )
              })}
            </div>
            <div style={{display: 'flex', flexDirection:'row'}}>
              <UserMenu />
            </div>
        </FlexMobileNotShow>
      </FlexMobileContainer>
      {/* <FlexMobileContainer>
        <FlexMobileNotShow maxWidth={768} style={{width: '100%'}} >
          <MobileNavbar />
        </FlexMobileNotShow>
      </FlexMobileContainer> */}

    </div>
  );
}

export default withRouter(NavbarComponent);

